<div class="page-container">
  <div class="page-header">
    <h1>Check-in History</h1>
    <p>Events you have attended</p>
  </div>

  <div class="checkin-card">
    <div class="table-container">
      <nz-table
        #checkInTable
        [nzData]="records"
        [nzLoading]="loading"
        [nzTotal]="totalItems"
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event)"
        nzSize="middle"
      >
        <thead>
          <tr>
            <th>Event</th>
            <th>Ticket</th>
            <th>Type</th>
            <th>Event Date</th>
            <th>Checked In</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of checkInTable.data">
            <td>
              <span class="event-name">{{ record.eventName }}</span>
            </td>
            <td>
              <span class="ticket-num">#{{ record.ticketNumber }}</span>
            </td>
            <td>
              <span class="type-badge">{{ record.ticketType }}</span>
            </td>
            <td class="text-secondary">{{ record.eventDate | date:'mediumDate' }}</td>
            <td class="text-secondary">{{ formatDate(record.checkInDate) }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
